export default function initMenuOpen() {
  const buttonTargets = document.querySelectorAll("[data-menu-button]");
  const menuRoot = document.querySelector(".menu");
  const menuLinks = document.querySelectorAll(".menu__link");

  const open = () => {
    if (menuRoot) {
      document.body.setAttribute("data-menu-open", "true");
      menuRoot.setAttribute("aria-hidden", "false");
      menuRoot.querySelector(".menu__close-button")?.focus();
    }
  };

  const close = () => {
    document.body.setAttribute("data-menu-open", "false");
    if (menuRoot) {
      menuRoot.setAttribute("aria-hidden", "true");
    }
  };

  buttonTargets.forEach((button) => {
    button.addEventListener("click", () => {
      if (menuRoot.getAttribute("aria-hidden") === "true") {
        open();
      } else {
        close();
      }
    });
  });

  document.addEventListener("click", function (event) {
    if (document.body.getAttribute("data-menu-open") === "true") {
      console.log(menuRoot?.contains(event.target));
      if (
        !menuRoot?.contains(event.target) &&
        !Array.from(buttonTargets).some((button) =>
          button.contains(event.target),
        )
      ) {
        close();
      }
    }
  });

  menuLinks.forEach((a) => {
    a.addEventListener("click", close);
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") close();
  });
}
